module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('seperator'), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.body), function(paragraph) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ffb9b38"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = 421
// module chunks = 1